import React, { useState, useEffect } from 'react';
import { app } from '../firebase'; // Importez votre configuration Firebase
import { getFirestore, collection, doc, updateDoc, onSnapshot, deleteDoc } from 'firebase/firestore'; 
import Loader from '../components/Loader';
import { useUser } from '../contexts/UserContext';
import DeleteModal from '../components/modals/DeleteModal';
import useDeleteUserFromCoownership from '../coownership/hooks/useDeleteUserFromCoownership';
import PrimaryButton from '../components/buttons/PrimaryButton';
import { downloadCsvFile } from '../librairies/CsvLib';

const db = getFirestore(app);

const ListUsersProvider = () => {

  const [usersProvider, setUsersProvider] = useState([]); 
  const [loader, setLoader] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false); 
  const [elementToDelete, setElementToDelete] = useState(null); 
  //contexte de l'utilisateur connecté
  const user = useUser();
  const { deleteProviderFromCoownership } = useDeleteUserFromCoownership(); 


  useEffect(() => {
    const collectionRef = collection(db, user.user.userData.lastCoownershipLoaded.path+"/usersProvider");

    const unsubscribe = onSnapshot(collectionRef, (snapshot) => {

      if(snapshot.docs.length > 0){
        
        let arr = [];

        snapshot.docs.map((owner) => {
          let obj = {
            id: owner.id, 
            firstname: owner.data().firstname, 
            lastname: owner.data().lastname, 
            company: owner.data().company ?? "",
            email: owner.data().email,
            phone: owner.data().phone,
          }

          arr.push(obj);

        });

        setUsersProvider(arr);
      }else{
        setUsersProvider([]);
      }

      setLoader(false);
    });

    return () => {
      console.log("unsubscribe");
      unsubscribe();
    }
  }, []); 

  useEffect(() => {
    if(elementToDelete != null){
      setShowDeleteModal(true); 
    }
  }, [elementToDelete]);

  useEffect(() => {
    if(showDeleteModal === false){
      setElementToDelete(null);
    }
  }, [showDeleteModal]);

  /**
   * On supprime un prestataire
   */
  const deleteProvider = async () => {
    if(elementToDelete !== null){
      deleteProviderFromCoownership(elementToDelete, user.user.userData.lastCoownershipLoaded.path); 
      setShowDeleteModal(false);
    }
  }

  const downloadCSV = () => {
    const headers = ["Prenom", "Nom", "Entreprise", "Email", "Telephone"];
    const rows = usersProvider.map((provider) => [
      provider.firstname || "",
      provider.lastname || "",
      provider.company || "",
      provider.email || "",
      provider.phone || "",
    ]);

    const coownershipId = user.user.userData.lastCoownershipLoaded?.id || "copropriete";
    downloadCsvFile({
      headers,
      rows,
      filename: `membres-prestataires-${coownershipId}.csv`,
    });
  };

  return (
    <div>
      {loader ? (
        <Loader />
      ) : (
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          <div className='flex gap-4 justify-end p-2'>
            <a href="#" onClick={(e) => { e.preventDefault(); downloadCSV(); }} className="justify-end flex mb-4">
              <PrimaryButton type={"button"} value={"Exporter en csv"} loading={false} />
            </a>
          </div>
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                    Prénom Nom
                </th>
                <th scope="col" className="px-6 py-3">
                    Entreprise
                </th>
                <th scope="col" className="px-6 py-3">
                    Email
                </th>
                <th scope="col" className="px-6 py-3">
                    Téléphone
                </th>
                <th scope="col" className="px-6 py-3">
                    Action
                </th>
              </tr>
            </thead>
            <tbody>
              {usersProvider.length > 0 ? 
                usersProvider.map((provider, key) => {
                  return (
                    <tr key={key} className={key % 2 === 0 ? "bg-white border-b dark:bg-gray-900 dark:border-gray-700" : "border-b bg-gray-50 dark:bg-gray-800 dark:border-gray-700"}>
                      <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        {provider.firstname} {provider.lastname}
                      </th>
                      <td className="px-6 py-4">
                        {provider.company}
                      </td>
                      <td className="px-6 py-4">
                        {provider.email}
                      </td>
                      <td className="px-6 py-4">
                        {provider.phone}
                      </td>
                      <td className="px-6 py-4">
                        <div className='flex gap-4'>
                          <a href="#" onClick={() => setElementToDelete(provider.id)} className="font-medium text-red-600 dark:text-red-500 hover:underline">Supprimer</a>
                        </div>
                      </td>
                    </tr>
                  )
                })
              : null }
            </tbody>
          </table>
        </div>
      )}

      {showDeleteModal ? (
        <DeleteModal closeAction={() => setShowDeleteModal(false)} confirmAction={() => deleteProvider()}/>
      ) : null }
    </div>
  );
};

export default ListUsersProvider;
